
/*
var flkty = new Flickity( '.ri-resources__list', {
    cellAlign: 'center',
    on: {
      ready: function() {
        var slides = document.querySelectorAll('.ri-resources__resource');
        for (var slide of slides) {
            slide.classList.add('eq-height');
        }
      }
    }
});
*/
setTimeout(function() {
  var slides = document.querySelectorAll('.ri-resources__resource');
  for (var slide of slides) {
      slide.classList.add('eq-height');
  }
}, 1000);


var bios = document.querySelectorAll('.ri-bios__bio');
for (var bio of bios) {
bio.onclick = function() {
  var bio_img = this.querySelector('.ri-bios__bio-img').innerHTML;
  var bio_name = this.querySelector('.ri-bios__bio-name').innerHTML;
  var bio_title = this.querySelector('.ri-bios__bio-title').innerHTML;
  var bio_desc = this.querySelector('.ri-bios__bio-desc').innerHTML;


  var div = document.createElement("div");

  div.className = 'ri-bios__popup';
  var bio_popup_markup = `<div class="ri-bios__popup-container">
    <div class="ri-bios__popup-scrollable">
      <button class="ri-bios__popup-close">✕</button>
      <div class="ri-bios__popup-content">
        <div class="ri-bios__popup-img">
          ${bio_img}
        </div>
        <div class="ri-bios__popup-name">${bio_name}</div>
        <div class="ri-bios__popup-title">${bio_title}</div>
        <div class="ri_bios__popup-desc">${bio_desc}</div>
      </div>
    </div>
  </div>`;
  div.innerHTML = bio_popup_markup;
  document.body.classList.add('ri-bio-popup-open');

  document.body.appendChild(div);

  var close_btn = div.querySelector('.ri-bios__popup-close');

  close_btn.onclick = function() {
    div.remove();
    document.body.classList.remove('ri-bio-popup-open');
  }

};
}
